import React, {useMemo} from 'react'
import axios from 'axios'
import classnames from 'classnames'
import {format} from 'date-fns'
import {makeStyles} from '@material-ui/core/styles'
import {
  Avatar,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Chip,
  Stepper,
  StepLabel,
  Step,
  Button,
} from '@material-ui/core'

import config from 'config'

import {
  PRODUCTION_STATUS_NO_LABEL,
  PRODUCTION_STATUS_SHIPPED,
  PRODUCTION_STATUS_TO_DO,
  PRODUCTION_STATUS_DONE,
  PRODUCTION_STATUS_TO_VERIFY,
  ProductionStatusLabel,
  CART_STATE_PAID,
} from '../../constants'
import getGinState from '../../utils/getGinState'
import getCartState from '../../utils/getCartState'
import getGinId from '../../utils/getGinId'
import useDownload from '../../hooks/useDownload'
import {useAuth} from '../../auth'

import Customizations from "./Customizations"
import MDG from "./MDG"

const bottlePng =
  'data:image/png;base64,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'

const useStyles = makeStyles((theme) => ({
  card: {
    minWidth: 900,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    // height: 'calc(100vh - 130px)'
  },
  details: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
  content: {
    width: '100%',
    marginLeft: theme.spacing(2),
  },
  cover: {
    margin: 10,
    width: 300,
    minWidth: 300,
    height: 300,
  },
  botanies: {
    display: 'flex',
    minWidth: 300,
    paddingRight: 10,
  },
  top: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 320,
  },

  col1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 300,
  },
  bottleCard: {
    display: 'flex',
    alignItems: 'center',
    width: 120,
    height: 90,
    marginRight: 10,
    marginBottom: 10,
  },
  productionCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 160,
    height: 90,
    backgroundColor: '#bedcbc',
    marginRight: 10,
    marginBottom: 10,
    '&.cardError': {
      height: 110,
      backgroundColor: '#e2909b',
    }
  },
  productionInnerCard: {
    display: 'flex',
    alignItems: 'center'
  },
  botanyCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 130,
    height: 130,
    marginRight: 10,
    marginBottom: 10,
  },
  botanyAvatar: {
    width: 50,
    height: 50,
    margin: 5,
    marginBottom: 15,
  },
  bottleAvatar: {
    margin: 5,
    width: 70,
    height: 70,
  },
  gridRoot: {
    width: '100%',
    flexGrow: 1,
  },
  productionState: {
    marginLeft: 20,
    color: 'white',
    fontWeight: 600,
    '&.toVerify': {
      backgroundColor: 'lightBlue',
    },
    '&.missingLabel': {
      backgroundColor: 'red',
    },
    '&.toDo': {
      backgroundColor: 'orange',
    },
    '&.done': {
      backgroundColor: 'saddlebrown',
    },
    '&.sent': {
      backgroundColor: 'green',
    },
  },
  upsell: {
    marginTop: '10px',
    backgroundColor: '#4d8e00',
    color: '#ffffff',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    borderRadius: '8px',
    width: '240px',
    padding: '4px',
    textAlign: 'center'
  },
  hashChanged: {
    backgroundColor: '#DC143C',
    color: '#ffffff',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    borderRadius: '8px',
    width: '240px',
    padding: '4px',
    textAlign: 'center'
  }
}))

const ProductionInfo = ({production, bottles}) => {
  const classes = useStyles()

  console.log(production)
  if (!production?.day) {
    return
  }

  const bottleErrors = bottles !== production.numbers.length

  return (
    <>
      <Card className={`${classes.productionCard} ${bottleErrors ? 'cardError' : ''}`}>
        <Typography variant="h3" style={{marginRight: 10, color: '#666'}}>
          Batch: {production.batch}
        </Typography>
        <div className={classes.productionInnerCard}>
          <Typography variant="h2" color="textSecondary">
            {format(new Date(production.day), 'yyyy-MM-dd')}
          </Typography>
        </div>
        <div className={classes.productionInnerCard}>
          <Typography variant="h2" color="textSecondary">
            {production.numbers.length <= 6
              ? production.numbers.join('-')
              : `${production.numbers[0]}...${
                production.numbers[production.numbers.length - 1]
              }`}
          </Typography>
        </div>
        {bottles !== production.numbers.length && <div>ATTENZIONE</div>}
      </Card>
    </>
  )
}

const Botany = ({botany}) => {
  const classes = useStyles()

  return (
    <Card className={classes.botanyCard}>
      <Avatar
        alt={botany.name}
        src={`${config.assetsPublicBaseUrl}images/botaniche/${botany.image}.jpg`}
        className={classes.botanyAvatar}
      />
      <Typography variant="h4" gutterBottom>
        {botany.name.substr(0, 15)}
      </Typography>
      <Typography variant="h2" color="textSecondary">
        {botany.intensity}
      </Typography>
    </Card>
  )
}

const Bottles = ({number}) => {
  const classes = useStyles()

  return (
    <Card className={classes.bottleCard}>
      <Avatar
        alt="Remy Sharp"
        src={bottlePng}
        className={classes.bottleAvatar}
      />
      <Typography variant="h2" color="textSecondary">
        {number}
      </Typography>
    </Card>
  )
}

const ProductionStatusClasses = {
  [PRODUCTION_STATUS_TO_VERIFY]: 'toVerify',
  [PRODUCTION_STATUS_NO_LABEL]: 'missingLabel',
  [PRODUCTION_STATUS_TO_DO]: 'toDo',
  [PRODUCTION_STATUS_DONE]: 'done',
  [PRODUCTION_STATUS_SHIPPED]: 'sent',
}

const ProductionStatus = ({order}) => {
  const classes = useStyles()
  const ginState = getGinState(order)
  const cartState = getCartState(order)
  return cartState === CART_STATE_PAID ? (
    <Chip
      className={classnames(classes.productionState, [
        ProductionStatusClasses[ginState],
      ])}
      label={ProductionStatusLabel[ginState]}
    />
  ) : (
    false
  )
}

function getSteps() {
  return ['Da fare', 'Fatto', 'Spedito']
}

function getStepIndex(productionState) {
  switch (productionState) {
    case PRODUCTION_STATUS_TO_DO:
      return 0
    case PRODUCTION_STATUS_DONE:
      return 1
    case PRODUCTION_STATUS_SHIPPED:
      return 2
    default:
      return 0
  }
}

const shouldShowSteps = (statoProduzione) =>
  [
    PRODUCTION_STATUS_TO_DO,
    PRODUCTION_STATUS_DONE,
    PRODUCTION_STATUS_SHIPPED,
  ].includes(statoProduzione)

const Order = ({order, refreshPage}) => {
  const classes = useStyles()
  const {download} = useDownload()
  const ginState = getGinState(order)
  const {getAccessToken} = useAuth()

  const productId = useMemo(() => {
    return getGinId(order)
  }, [order])

  const handleDownloadCertificate = async () => {
    const accessToken = await getAccessToken()

    const result = await axios.get(
      `${config.labelsApiUrl}download-certificate-pdf?ginId=${order.ginId}`,
      {
        headers: {
          Authorization: `bearer ${accessToken}`,
        },
      }
    )

    download(config.staticsPublicBaseUrl + result.data.key)
  }
  const handleDownloadLabel = async () => {
    const accessToken = await getAccessToken()

    const result = await axios.get(
      `${config.labelsApiUrl}download-label-image?ginId=${order.ginId}`,
      {
        headers: {
          Authorization: `bearer ${accessToken}`,
        },
      }
    )

    download(config.staticsPublicBaseUrl + result.data.key)
  }

  const handleDownloadLabelPDF = async () => {
    const accessToken = await getAccessToken()

    const result = await axios.get(
      `${config.labelsApiUrl}download-label-pdf?ginId=${order.ginId}`,
      {
        headers: {
          Authorization: `bearer ${accessToken}`,
        },
      }
    )

    download(config.staticsPublicBaseUrl + result.data.key)
  }

  return (
    <Card className={classes.card} elevation={0}>
      {shouldShowSteps(ginState) ? (
        <Stepper activeStep={getStepIndex(ginState)}>
          {getSteps().map((label, index) => {
            const stepProps = {}
            const labelProps = {}
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            )
          })}
        </Stepper>
      ) : (
        false
      )}
      <div className={classes.top}>
        <CardMedia
          className={classes.cover}
          image={order.labelImage}
          title=""
        />
        <div className={classes.details}>
          <CardContent className={classes.content}>
            <div className={classes.col1}>
              <div>
                <Typography variant="h6" gutterBottom>
                  Ordine n° {productId}
                  {order.relatedProducts?.length && (
                    <span style={{color: 'red'}}> Carrello multiplo</span>
                  )}
                  {order.productId === 'GIN-0003' && <span style={{color: 'orange'}}>{' '}(50%)</span>}
                  <ProductionStatus order={order}/>
                </Typography>
                <Typography variant="h6" gutterBottom>
                  {order.paymentDate &&
                    format(new Date(order.paymentDate), 'yyyy-MM-dd HH:mm')}
                </Typography>

                <Typography variant="body1" gutterBottom>
                  Nome
                </Typography>
                <Typography variant="h2" color="textSecondary" gutterBottom>
                  {order.ginName}
                </Typography>

                <a
                  href={`https://iltuogin.it/builder2?ginId=${order.ginId}&label=true&fromProd=true`}
                >
                  Modifica etichetta
                </a>
              </div>
              <div>
                <div style={{display: 'flex'}}>

                  <Bottles number={order.quantity}/>
                  <ProductionInfo production={order.production} bottles={order.quantity}/>
                </div>
                <Typography variant="h2" color="textPrimary">
                  Packaging:&nbsp;&nbsp;&nbsp;
                  <span style={{color: '#AF1818'}}>
                    {order.customizations?.packaging?.id || order.params?.packaging ||
                      (order.params?.code ? 'box' : 'Verificare il packaging')}
                  </span>
                </Typography>
                <Customizations order={order}/>
              </div>
              {(order.upsellProducts?.length || order.hasFakeUpselling) ?
                <div className={classes.upsell}>Ordine contiene UPSELL</div> : ''}
              {order.hashChanged ? <div className={classes.hashChanged}>Ordine modificato dopo pagamento</div> : ''}
            </div>
          </CardContent>
        </div>
      </div>
      {/* {order.orderData && order.orderData.notes && ( */}
      <Box width={500} display="flex">
        <Box mr={2}>
          <Button
            fullWidth
            variant="outlined"
            className={classes.button}
            onClick={() => handleDownloadCertificate()}
          >
            Certificato
          </Button>
        </Box>
        <Box mr={2}>
          <Button
            fullWidth
            variant="outlined"
            className={classes.button}
            onClick={() => handleDownloadLabel()}
          >
            Etichetta
          </Button>
        </Box>
        <Box mr={2}>
          <Button
            fullWidth
            variant="outlined"
            className={classes.button}
            onClick={() => handleDownloadLabelPDF()}
          >
            PDF
          </Button>
        </Box>
      </Box>
      <MDG order={order} refreshPage={refreshPage}/>
      <div>
        <a target='_new' href={`https://shop.iltuogin.it/wp-admin/post.php?post=${order.ginshopOrderId}&action=edit `}>Ordine Shop <strong>{order.ginshopOrderId}</strong></a>
      </div>
      {order.notes && (
        <CardContent>
          <Typography variant="h3" color="textSecondary" gutterBottom>
            Note
          </Typography>

          {order.notes?.split('\n').map((text, index) => (
            <Typography key={index}>{text}</Typography>
          ))}
        </CardContent>
      )}
      {/* )} */}
      <CardContent className={classes.content}>
        <Typography variant="h2" color="secondary" gutterBottom>
          Botaniche
        </Typography>
        <Box className={classes.botanies}>
          {order.recipe.botanics.map((botany) => (
            <Botany key={botany.id} botany={botany}/>
          ))}
        </Box>
      </CardContent>
    </Card>
  )
}

export default Order
